import React, { createContext, useState, useEffect, useContext } from 'react';
import { connectSocket, disconnectSocket, getSocket } from '../config/socket';
import { AuthContext } from './AuthContext';

export const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      connectSocket().then((s) => setSocket(s));
    } else {
      disconnectSocket();
      setSocket(null);
    }

    return () => disconnectSocket();
  }, [isAuthenticated]);

  return (
    <SocketContext.Provider value={{ socket, getSocket }}>
      {children}
    </SocketContext.Provider>
  );
};
